// src/store/slices/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';

let nextId = 0;

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    notifications: []
  },
  reducers: {
    addNotification: {
      reducer(state, action) {
        state.notifications.push(action.payload);
      },
      prepare({ type = 'info', title, message, duration = 5000 }) {
        return {
          payload: {
            id: ++nextId,
            type,
            title,
            message,
            duration,
            createdAt: Date.now(),
          }
        };
      }
    },
    removeNotification(state, action) {
      state.notifications = state.notifications.filter(
        (n) => n.id !== action.payload
      );
    }
  }
});

export const { addNotification, removeNotification } = uiSlice.actions;
export default uiSlice.reducer;
